export const MESSAGE_ACTIONS_CLASSTALK = ['delete'];
